import SwitchBar from '../../components/switch-bar';
import { useClient, useUpdateClient } from '../../hooks/useClients';
import { HeaderOptions } from './clients-constants';
import HeadBack from './redirect';
import Header from '../../components/common/global-top-bar';
import { useForm } from 'react-hook-form';
import { useEffect, useMemo, useRef } from 'react';
import { toast } from 'react-toastify';

export const ClientPeersonaConfig = () => {
  const clientId = +localStorage.getItem('clientid')!;
  const { data: client } = useClient(clientId);
  const { updateClient } = useUpdateClient(parseInt(clientId!), true);

  enum ClientPeersonaConfigKeys {
    check_in_message = 'check_in_message',
    check_in_frequency = 'check_in_frequency',
  }

  const defaultValues = useMemo(() => {
    return {
      check_in_message: client?.check_in_message,
      check_in_frequency: client?.check_in_frequency,
    };
  }, [client?.check_in_message, client?.check_in_frequency]);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { isValid },
  } = useForm({
    defaultValues: defaultValues,
  });

  useEffect(() => {
    if (client) {
      reset(defaultValues);
    }
  }, [client, defaultValues, reset]);

  const cancelRef = useRef() as React.MutableRefObject<HTMLButtonElement>;

  const onSubmit = (data: any) => {
    const payload = {
      check_in_message: data.check_in_message,
      check_in_frequency: data.check_in_frequency,
    };
    if (clientId) {
      updateClient.mutate(payload, {
        onSuccess: () => {
          cancelRef.current.classList.remove('bg-red');
          cancelRef.current.classList.add('bg-gray-background-dark');
          toast.success('Client Peersona Configuration updated successfully!');
        },
        onError: (error: any) => {
          toast.error(error.response.data.description);
        },
      });
    } else {
      toast.error('No client loaded');
    }
  };
  const handleCancel = () => {
    reset(defaultValues);
    cancelRef.current.classList.remove('bg-red');
    cancelRef.current.classList.add('bg-gray-background-dark');
  };

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement | HTMLSelectElement>,
    key: ClientPeersonaConfigKeys,
  ) => {
    setValue(key, e.target.value);
    cancelRef.current.classList.remove('bg-gray-background-dark');
    cancelRef.current.classList.add('bg-red');
  };
  return (
    <div key={client?.id}>
      <Header heading={<HeadBack clientName={client?.name || ''} />} />
      <SwitchBar heading={HeaderOptions} position={7} />
      <div className="p-8">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-8">
            <label htmlFor="check_in_frequency" className="mb-2 block text-lg font-medium text-gray-700">
              Resource Assistant Trigger Timing Seconds
            </label>
            <h2 className="text-md mb-2 text-gray-900">Seconds between check-in evaluations.</h2>
            <input
              id="check_in_frequency"
              {...register('check_in_frequency')}
              onChange={(e) => handleValueChange(e, ClientPeersonaConfigKeys.check_in_frequency)}
              data-testid="check_in_frequency"
              className="focus:ring-bright-blue focus:border-bright-blue w-lg rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:outline-none"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="check_in_message" className="mb-2 block text-lg font-medium text-gray-700">
              Resource Assistant Message
            </label>
            <h2 className="text-md mb-2 text-gray-900">Message displayed to user when presenting resources.</h2>
            <textarea
              id="check_in_message"
              {...register('check_in_message')}
              onChange={(e) => handleValueChange(e, ClientPeersonaConfigKeys.check_in_message)}
              className="focus:ring-bright-blue focus:border-bright-blue resize-vertical h-64 w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:outline-none"
              placeholder="Enter message presenting resources..."
              data-testid="check_in_message"
            />
          </div>

          <div className="flex justify-end space-x-4">
            <button
              type="submit"
              disabled={!isValid}
              className="bg-bright-blue rounded-full px-6 py-2 font-medium text-white transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-400"
              data-testid="client-peersona-config-save-button"
            >
              {updateClient.isLoading ? 'Saving...' : 'Save'}
            </button>

            <button
              type="button"
              ref={cancelRef}
              onClick={handleCancel}
              className="bg-gray-background-dark rounded-full px-6 py-2 font-medium text-white transition-colors hover:bg-gray-600"
              data-testid="client-peersona-config-cancel-button"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
